'use client'

// The town clock, standing at the end of the east street.
//
// Sam's model, placed in Blender at [114.7, 1.57, 5.97] with its own
// scale and rotation, so this renders at IDENTITY like the ruins, the
// piano and the junk heap. Wrapping it in a group at the POI would add
// the two together and put an eighteen-metre tower somewhere off the
// map.
//
// The POI he walks to (windClock) sits a few metres west of it, on the
// side he arrives from, so he stands at the foot of it rather than
// inside it. Moving the tower means moving it in Blender; moving where
// he stands means the POI.
//
// The hands are painted into the texture and do not move. That is
// deliberate for now and worth knowing: the DRIFT is real and lives in
// the sim, and what he reads is in his percept, not on this mesh. A
// viewer sees a clock tower; they do not see it running slow. Making
// the hands turn means overlaying two thin meshes on the face and
// rotating them from entity.state.driftMin, which is a small job and a
// separate one.

import { useSceneNodeMaterials } from '../hooks/useSceneNodeMaterials'
import { useModel } from '../hooks/useModel'

const MODEL = '/models/clockTower.glb'

export function ClockTower() {
  const { scene } = useModel(MODEL)

  useSceneNodeMaterials(scene, { roughness: 0.92 })

  // Baked transform: render at identity.
  return <primitive object={scene} />
}


export default ClockTower
